import { ProjectStatus } from '../types'

export interface StatusConfig {
  label: string
  color: string
  bgColor: string
  icon?: string
}

export const PROJECT_STATUS_CONFIG: Record<ProjectStatus, StatusConfig> = {
  [ProjectStatus.NOT_STARTED]: {
    label: 'Not Started',
    color: 'text-slate-600',
    bgColor: 'bg-slate-100',
  },
  [ProjectStatus.DRAFT]: {
    label: 'Draft',
    color: 'text-gray-600',
    bgColor: 'bg-gray-100',
  },
  [ProjectStatus.NEEDS_REVISION]: {
    label: 'Needs Revision',
    color: 'text-orange-700',
    bgColor: 'bg-orange-100',
  },
  [ProjectStatus.QA_PENDING]: {
    label: 'QA Pending',
    color: 'text-blue-700',
    bgColor: 'bg-blue-100',
  },
  [ProjectStatus.QA_APPROVED]: {
    label: 'QA Approved',
    color: 'text-green-700',
    bgColor: 'bg-green-100',
  },
  [ProjectStatus.ARCHIVED]: {
    label: 'Archived',
    color: 'text-gray-500',
    bgColor: 'bg-gray-50',
  },
}

export function getStatusConfig(status: ProjectStatus): StatusConfig {
  return PROJECT_STATUS_CONFIG[status] || PROJECT_STATUS_CONFIG[ProjectStatus.DRAFT]
}

export function getStatusLabel(status: ProjectStatus): string {
  return getStatusConfig(status).label
}
